export default {
  DOT: 46,
  COMMA: 44,
};
